export default __webpack_public_path__ + "static/media/sketch06.04d2473e.png";